<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-col md:w-full" v-if="this.params.data.registerPackageStatus == 0">
            <vx-tooltip class="f-r" text="Phê duyệt" position="top">
                <feather-icon icon="CheckIcon" class="icon-action"
                              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                              @click="confirmAccept"/>
            </vx-tooltip>

            <vx-tooltip class="f-r" text="Từ chối" position="top">
                <feather-icon icon="XIcon" class="icon-action1"
                              svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer"
                              @click="confirmReject"/>
            </vx-tooltip>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'CellRendererActions',
        methods: {
            confirmAccept() {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'primary',
                    title: `Xác nhận đồng ý yêu cầu.`,
                    text: `Bạn có chắc là muốn đồng ý yêu cầu nâng cấp gói "${this.params.data.organizationPackageResponseDTO.packageName}" không ?`,
                    accept: this.acceptRecord,
                    acceptText: "Đồng ý",
                    cancelText: "Huỷ"
                })
            },

            acceptRecord() {
                this.$vs.loading();
                this.$crm.post(`/organization-package-history/accept/${this.params.data.id}/${this.params.data.organizationId}`).then(() => {
                    this.$vs.loading.close();
                    return this.showAcceptSuccess("Hệ thống sẽ được nâng cấp trong ít phút.");
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            },

            showAcceptSuccess(text) {
                this.$store.commit('UPDATE_REQUEST_PACKAGE', true);
                this.$vs.notify({
                    color: 'success',
                    text: text,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            },

            confirmReject() {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Xác nhận hủy bỏ yêu cầu.`,
                    text: `Bạn có chắc là muốn hủy bỏ yêu cầu nâng cấp gói "${this.params.data.organizationPackageResponseDTO.packageName}" không ?`,
                    accept: this.rejectRecord,
                    acceptText: "Đồng ý",
                    cancelText: "Huỷ"
                })
            },
            rejectRecord() {
                this.$vs.loading();
                this.$crm.post(`/organization-package-history/reject/${this.params.data.id}/${this.params.data.organizationId}`).then(() => {
                    this.$vs.loading.close();
                    return this.showAcceptSuccess("Từ chối nâng cấp gói thành công.");
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            },
        }
    }
</script>
<style scoped>

    .f-r {
        float: right;
    }

    .icon-action {
        color: #059862;
    }

    .icon-action:hover {
        color: #059862;
        opacity: 0.5;
    }

    .icon-action1 {
        color: red;
    }

    .icon-action1:hover {
        color: red;
        opacity: 0.5;
    }

</style>

